import { createSlice } from '@reduxjs/toolkit'

export const usedParametersInDiagramSlice = createSlice({
    name: 'usedParametersInDiagram',
    initialState: {
        result: [],
    },
    reducers: {
        setUsedParametersInDiagram: (state, action) => {
            state.result = action.payload;
        },
    },
})

export const { setUsedParametersInDiagram } = usedParametersInDiagramSlice.actions;

export const getUsedParametersInDiagram = (state) => state.usedParametersInDiagram.result;

export default usedParametersInDiagramSlice.reducer